import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    STUDIO: 'HostGator Studio',
  },
  ACTION: {
    CREATE_SITE_TOP: 'Clique no Botão - Criar site com IA',
    CREATE_SITE_BOTTOM: 'Clique no Botão - Criar site com IA',
    REMOVE_BACKGROUND: 'Clique na Funcionalidade',
    BRAND_KIT: 'Clique na Funcionalidade',
    PROJECTS: 'Clique no Botão - Projetos',
    OPEN_EDITOR: 'Clique no Botão - Abrir editor ( + )',
    OPEN_TEMPLATE: 'Clique no Template',
    BANNER_PRO: 'Clique no Botão - Experimente o Pro',
    SHOW_MORE_TEMPLATES: 'Clique no Botão - Mostrar mais templates',
    CREATE_LOGO: 'Clique no Botão - Criar logo',
    GO_TO_STUDIO: 'Clique no Botão - Ir para o Studio',
    DOWNLOAD_LOGO: 'Clique no Botão - Baixar',
    EDIT_LOGO: 'Clique no Botão - Editar',
    GENERATE_MORE_OPTIONS: 'Clique no Botão - Gerar mais opções',
    FEATURE_NO_CREDITS_CTA: 'Clique na Funcionalidade - Saldo insuficiente',
    STUDIO_FREE_CTA: 'Clique na Funcionalidade - Studio Grátis',
    BANNER_ADVERTISEMENT_TOP_PAGE_SITES: 'Clique no Banner - Começar',
    BANNER_ADVERTISEMENT_BOTTOM_PAGE_SITES: 'Clique no Banner - Começar',
    BANNER_ADVERTISEMENT_PAGE_PRODUCTS: 'Clique no Banner - Começar',
    BANNER_ADVERTISEMENT_PAGE_TOOLS: 'Clique no Banner - Começar',
    BANNER_ADVERTISEMENT_PAGE_COURSES: 'Clique no Banner - Começar',
  },
  LABEL: {
    CREATE_SITE_TOP: 'Dashboard - Crie site com IA - Superior',
    CREATE_SITE_BOTTOM: 'Dashboard - Crie site com IA - Inferior',
    REMOVE_BACKGROUND: 'Dashboard - Remover fundo com IA',
    BRAND_KIT: 'Dashboard - Kit de marca',
    PROJECTS: 'Dashboard - Projetos',
    OPEN_EDITOR: 'Dashboard - Abrir editor',
    OPEN_TEMPLATE: 'Dashboard - Abrir template',
    BANNER_PRO: 'Dashboard - Listagem de formatos de templates',
    SHOW_MORE_TEMPLATES: 'Dashboard - Listagem de formatos de templates',
    CREATE_LOGO: 'Criador de logo com IA - Sobre sua marca',
    GO_TO_STUDIO: 'Criador de logo com IA - Sobre sua marca',
    DOWNLOAD_LOGO: 'Logo criado',
    EDIT_LOGO: 'Logo criado',
    GENERATE_MORE_OPTIONS: 'Logo criado',
    BACKGROUND_REMOVER_NO_CREDITS_CTA: 'Dashboard - Remover fundo com IA - Saldo insuficiente',
    BACKGROUND_REMOVER_STUDIO_FREE_CTA: 'Dashboard - Remover fundo com IA - Studio Grátis',
    BRAND_KIT_NO_CREDITS_CTA: 'Dashboard - Kit de marca - Saldo insuficiente',
    BRAND_KIT_STUDIO_FREE_CTA: 'Dashboard - Kit de marca - Studio Grátis',
    BANNER_ADVERTISEMENT_TOP_PAGE_SITES: 'Sites - Banner HostGator Studio',
    BANNER_ADVERTISEMENT_BOTTOM_PAGE_SITES: 'Sites - Banner HostGator Studio - Inferior',
    BANNER_ADVERTISEMENT_PAGE_PRODUCTS: 'Hospedagens e Servidores - Banner HostGator Studio',
    BANNER_ADVERTISEMENT_PAGE_TOOLS: 'Ferramentas e Serviços - Banner HostGator Studio',
    BANNER_ADVERTISEMENT_PAGE_COURSES: 'Cursos - Banner HostGator Studio',
  },
};

const events = {
  createSiteTopClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_SITE_TOP,
    label: EVENT.LABEL.CREATE_SITE_TOP,
  },
  createSiteBottomClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_SITE_BOTTOM,
    label: EVENT.LABEL.CREATE_SITE_BOTTOM,
  },
  removeBackgroundClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.REMOVE_BACKGROUND,
    label: EVENT.LABEL.REMOVE_BACKGROUND,
  },
  brandKitClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BRAND_KIT,
    label: EVENT.LABEL.BRAND_KIT,
  },
  projectsClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.PROJECTS,
    label: EVENT.LABEL.PROJECTS,
  },
  openEditorClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.OPEN_EDITOR,
    label: EVENT.LABEL.OPEN_EDITOR,
  },
  openTemplateClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.OPEN_TEMPLATE,
    label: EVENT.LABEL.OPEN_TEMPLATE,
  },
  bannerProClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_PRO,
    label: EVENT.LABEL.BANNER_PRO,
  },
  showMoreTemplatesClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.SHOW_MORE_TEMPLATES,
    label: EVENT.LABEL.SHOW_MORE_TEMPLATES,
  },
  createLogoClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_LOGO,
    label: EVENT.LABEL.CREATE_LOGO,
  },
  goToStudioClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.GO_TO_STUDIO,
    label: EVENT.LABEL.GO_TO_STUDIO,
  },
  downloadLogoClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.DOWNLOAD_LOGO,
    label: EVENT.LABEL.DOWNLOAD_LOGO,
  },
  editLogoClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.EDIT_LOGO,
    label: EVENT.LABEL.EDIT_LOGO,
  },
  generateMoreOptionsClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.GENERATE_MORE_OPTIONS,
    label: EVENT.LABEL.GENERATE_MORE_OPTIONS,
  },
  backgroundRemoverNoCreditsCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.FEATURE_NO_CREDITS_CTA,
    label: EVENT.LABEL.BACKGROUND_REMOVER_NO_CREDITS_CTA,
  },
  backgroundRemoverStudioFreeCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.STUDIO_FREE_CTA,
    label: EVENT.LABEL.BACKGROUND_REMOVER_STUDIO_FREE_CTA,
  },
  brandKitNoCreditsCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.FEATURE_NO_CREDITS_CTA,
    label: EVENT.LABEL.BRAND_KIT_NO_CREDITS_CTA,
  },
  brandKitStudioFreeCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.STUDIO_FREE_CTA,
    label: EVENT.LABEL.BRAND_KIT_STUDIO_FREE_CTA,
  },
  bannerAdvertisementTopPageSites: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_ADVERTISEMENT_TOP_PAGE_SITES,
    label: EVENT.LABEL.BANNER_ADVERTISEMENT_TOP_PAGE_SITES,
  },
  bannerAdvertisementBottomPageSites: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_ADVERTISEMENT_BOTTOM_PAGE_SITES,
    label: EVENT.LABEL.BANNER_ADVERTISEMENT_BOTTOM_PAGE_SITES,
  },
  bannerAdvertisementPageProducts: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_ADVERTISEMENT_PAGE_PRODUCTS,
    label: EVENT.LABEL.BANNER_ADVERTISEMENT_PAGE_PRODUCTS,
  },
  bannerAdvertisementPageTools: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_ADVERTISEMENT_PAGE_TOOLS,
    label: EVENT.LABEL.BANNER_ADVERTISEMENT_PAGE_TOOLS,
  },
  bannerAdvertisementPageCourses: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_ADVERTISEMENT_PAGE_COURSES,
    label: EVENT.LABEL.BANNER_ADVERTISEMENT_PAGE_COURSES,
  },
};

const createSiteTopClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.createSiteTopClick.campaign,
    gaEventAction: events.createSiteTopClick.action,
    gaEventLabel: events.createSiteTopClick.label,
  });
  collectTrackData(events.createSiteTopClick);
};

const createSiteBottomClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.createSiteBottomClick.campaign,
    gaEventAction: events.createSiteBottomClick.action,
    gaEventLabel: events.createSiteBottomClick.label,
  });
  collectTrackData(events.createSiteBottomClick);
};

const logoCreatorClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.logoCreatorClick.campaign,
    gaEventAction: events.logoCreatorClick.action,
    gaEventLabel: events.logoCreatorClick.label,
  });
  collectTrackData(events.logoCreatorClick);
};

const removeBackgroundClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.removeBackgroundClick.campaign,
    gaEventAction: events.removeBackgroundClick.action,
    gaEventLabel: events.removeBackgroundClick.label,
  });
  collectTrackData(events.removeBackgroundClick);
};

const brandKitClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.brandKitClick.campaign,
    gaEventAction: events.brandKitClick.action,
    gaEventLabel: events.brandKitClick.label,
  });
  collectTrackData(events.brandKitClick);
};

const projectsClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.projectsClick.campaign,
    gaEventAction: events.projectsClick.action,
    gaEventLabel: events.projectsClick.label,
  });
  collectTrackData(events.projectsClick);
};

const openEditorClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.openEditorClick.campaign,
    gaEventAction: events.openEditorClick.action,
    gaEventLabel: events.openEditorClick.label,
  });
  collectTrackData(events.openEditorClick);
};

const openTemplateClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.openTemplateClick.campaign,
    gaEventAction: events.openTemplateClick.action,
    gaEventLabel: events.openTemplateClick.label,
  });
  collectTrackData(events.openTemplateClick);
};

const bannerProClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.bannerProClick.campaign,
    gaEventAction: events.bannerProClick.action,
    gaEventLabel: events.bannerProClick.label,
  });
  collectTrackData(events.bannerProClick);
};

const showMoreTemplatesClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.showMoreTemplatesClick.campaign,
    gaEventAction: events.showMoreTemplatesClick.action,
    gaEventLabel: events.showMoreTemplatesClick.label,
  });
  collectTrackData(events.showMoreTemplatesClick);
};

const createLogoClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.createLogoClick.campaign,
    gaEventAction: events.createLogoClick.action,
    gaEventLabel: events.createLogoClick.label,
  });
  collectTrackData(events.createLogoClick);
};

const modalLogoButtonBackClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.modalLogoButtonBackClick.campaign,
    gaEventAction: events.modalLogoButtonBackClick.action,
    gaEventLabel: events.modalLogoButtonBackClick.label,
  });
  collectTrackData(events.modalLogoButtonBackClick);
};

const goToStudioClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.goToStudioClick.campaign,
    gaEventAction: events.goToStudioClick.action,
    gaEventLabel: events.goToStudioClick.label,
  });
  collectTrackData(events.goToStudioClick);
};

const downloadLogoClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.downloadLogoClick.campaign,
    gaEventAction: events.downloadLogoClick.action,
    gaEventLabel: events.downloadLogoClick.label,
  });
  collectTrackData(events.downloadLogoClick);
};

const editLogoClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.editLogoClick.campaign,
    gaEventAction: events.editLogoClick.action,
    gaEventLabel: events.editLogoClick.label,
  });
  collectTrackData(events.editLogoClick);
};

const generateMoreOptionsClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.generateMoreOptionsClick.campaign,
    gaEventAction: events.generateMoreOptionsClick.action,
    gaEventLabel: events.generateMoreOptionsClick.label,
  });
  collectTrackData(events.generateMoreOptionsClick);
};

const createLogoManuallyClick = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.createLogoManuallyClick.campaign,
    gaEventAction: events.createLogoManuallyClick.action,
    gaEventLabel: events.createLogoManuallyClick.label,
  });
  collectTrackData(events.createLogoManuallyClick);
};

const backgroundRemoverNoCreditsCta = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.backgroundRemoverNoCreditsCta.campaign,
    gaEventAction: events.backgroundRemoverNoCreditsCta.action,
    gaEventLabel: events.backgroundRemoverNoCreditsCta.label,
  });
  collectTrackData(events.backgroundRemoverNoCreditsCta);
};

const backgroundRemoverStudioFreeCta = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.backgroundRemoverStudioFreeCta.campaign,
    gaEventAction: events.backgroundRemoverStudioFreeCta.action,
    gaEventLabel: events.backgroundRemoverStudioFreeCta.label,
  });
  collectTrackData(events.backgroundRemoverStudioFreeCta);
};

const brandKitNoCreditsCta = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.brandKitNoCreditsCta.campaign,
    gaEventAction: events.brandKitNoCreditsCta.action,
    gaEventLabel: events.brandKitNoCreditsCta.label,
  });
  collectTrackData(events.brandKitNoCreditsCta);
};

const brandKitStudioFreeCta = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.brandKitStudioFreeCta.campaign,
    gaEventAction: events.brandKitStudioFreeCta.action,
    gaEventLabel: events.brandKitStudioFreeCta.label,
  });
  collectTrackData(events.brandKitStudioFreeCta);
};

const bannerAdvertisementTopPageSites = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.bannerAdvertisementTopPageSites.campaign,
    gaEventAction: events.bannerAdvertisementTopPageSites.action,
    gaEventLabel: events.bannerAdvertisementTopPageSites.label,
  });
  collectTrackData(events.bannerAdvertisementTopPageSites);
};

const bannerAdvertisementBottomPageSites = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.bannerAdvertisementBottomPageSites.campaign,
    gaEventAction: events.bannerAdvertisementBottomPageSites.action,
    gaEventLabel: events.bannerAdvertisementBottomPageSites.label,
  });
  collectTrackData(events.bannerAdvertisementBottomPageSites);
};

const bannerAdvertisementPageProducts = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.bannerAdvertisementPageProducts.campaign,
    gaEventAction: events.bannerAdvertisementPageProducts.action,
    gaEventLabel: events.bannerAdvertisementPageProducts.label,
  });
  collectTrackData(events.bannerAdvertisementPageProducts);
};

const bannerAdvertisementPageTools = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.bannerAdvertisementPageTools.campaign,
    gaEventAction: events.bannerAdvertisementPageTools.action,
    gaEventLabel: events.bannerAdvertisementPageTools.label,
  });
  collectTrackData(events.bannerAdvertisementPageTools);
};

const bannerAdvertisementPageCourses = () => {
  collect({
    event: 'gaEvent',
    gaEventCategory: events.bannerAdvertisementPageCourses.campaign,
    gaEventAction: events.bannerAdvertisementPageCourses.action,
    gaEventLabel: events.bannerAdvertisementPageCourses.label,
  });
  collectTrackData(events.bannerAdvertisementPageCourses);
};

const analytics = {
  createSiteTopClick,
  createSiteBottomClick,
  logoCreatorClick,
  removeBackgroundClick,
  brandKitClick,
  projectsClick,
  openEditorClick,
  openTemplateClick,
  bannerProClick,
  showMoreTemplatesClick,
  createLogoClick,
  modalLogoButtonBackClick,
  goToStudioClick,
  downloadLogoClick,
  editLogoClick,
  generateMoreOptionsClick,
  createLogoManuallyClick,
  backgroundRemoverNoCreditsCta,
  backgroundRemoverStudioFreeCta,
  brandKitNoCreditsCta,
  brandKitStudioFreeCta,
  bannerAdvertisementTopPageSites,
  bannerAdvertisementBottomPageSites,
  bannerAdvertisementPageProducts,
  bannerAdvertisementPageTools,
  bannerAdvertisementPageCourses,
};

export default analytics;
